import React from 'react'
import { useHistory } from 'react-router-dom';
import HomeView from "../../views/ver_24.10/Home.view";

const HomePage= () =>{
    const history = useHistory();
    const actions = {
        navigateToProgramCreator: () => history.push('/program/new'),
        navigateToFrameworkCreator: () => history.push('/framework/new'),
        navigateToReportTypes: () => history.push('/rating/program/welcome'),
        navigateToDQGuide: () => history.push('/dq-guide'),
        navigateToAssessmentCreator: () => history.push('/rating/programs/assessment/list'),
    };

    return(
        <>
            <div>
                <HomeView
                    actions={actions}
                />
            </div>
        </>
    );
}

export default HomePage;